import { useState } from 'react';
import CopyIcon from '../../../assets/icon-copy-unselected.svg?react';
import TickIcon from '../../../assets/icon-google-tick.svg?react';
import CheveronIcon from '../../../assets/icon-cheveron.svg?react';

interface SQLStep {
  label: string;
  code: string;
  result?: string;
}

interface CollapsibleCardProps {
  title: string;
  content: SQLStep[];
  defaultOpen?: boolean;
}

const CollapsibleCard = ({
  title = 'Intermediate',
  content,
  defaultOpen = false,
}: CollapsibleCardProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const copyToClipboard = (text: string, index: number) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => {
      setCopiedIndex(null);
    }, 2000);
  };

  return (
    <div className="collapsible-card">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-100 d-flex align-items-center justify-content-between card-header-btn ${isOpen ? 'open' : 'collapsed'}`}
      >
        <span className="sql-btn-title">{title}</span>
        <span className="chevron">
          <CheveronIcon />
        </span>
      </button>

      {isOpen && (
        <div className="card-content">
          <div className="px-4 pt-1">
            {content.map((section, index) => (
              <div key={index} className="position-relative mb-4">
                <div className="mb-2">
                  <span className="fw-semibold code-label">{section.label}</span>
                </div>
                <div className="position-relative rounded code-block-wrapper">
                  <pre className="sql-block">
                    <code>{section.code}</code>
                  </pre>
                  <div className="d-flex justify-content-end border-top code-block-footer">
                    {copiedIndex === index ? (
                      <span className="copied-badge">
                        <TickIcon />
                        <span>Copied</span>
                      </span>
                    ) : (
                      <button
                        onClick={() => copyToClipboard(section.code, index)}
                        className="btn copy-btn"
                        title="Copy code"
                      >
                        <CopyIcon className="copy-icon" />
                      </button>
                    )}
                  </div>
                </div>

                {/* Show result if available */}
                {/* {section.result && (
                  <>
                    <div className="mb-2 mt-3">
                      <span className="fw-semibold code-label">Result</span>
                    </div>
                    <div className="position-relative rounded code-block-wrapper">
                      <pre className="p-3 overflow-auto mb-0">
                        <code className="font-monospace code-content">{section.result}</code>
                      </pre>
                      <div className="d-flex justify-content-end border-top code-block-footer">
                        {copiedIndex === `result-${index}` ? (
                          <span className="copied-badge">
                            <TickIcon />
                            <span>Copied</span>
                          </span>
                        ) : (
                          <button
                            onClick={() =>
                              copyToClipboard(section.result!, `result-${index}` as any)
                            }
                            className="btn copy-btn"
                            title="Copy result"
                          >
                            <CopyIcon className="copy-icon" />
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                )} */}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleCard;
